module.exports = __webpack_public_path__ + "img/122.2382be28.png";